<div class="chatbot-wrapper">

  <div class="chat-messages" role="log" aria-live="polite">
    <div *ngFor="let m of messages" class="message-row" [ngClass]="{ 'user-row': m.from === 'user', 'bot-row': m.from === 'bot' }">
      <div class="avatar" *ngIf="m.from === 'bot'"> <span class="avatar-initial">B</span> </div>
      <div class="message-col">
        <div class="message-card">
          <div class="message-text" [innerText]="m.text"></div>
        </div>
        <div class="message-meta">{{ m.time | date:'short' }}</div>
      </div>
      <div class="avatar user-avatar" *ngIf="m.from === 'user'"> <span class="avatar-initial">{{ getUserInitial() }}</span> </div>
    </div>
  </div>

  <div class="chat-input-row">
    <input class="chat-input" placeholder="Enter your response..." [(ngModel)]="newMessage" (keydown.enter)="sendMessage()" />
    <button class="send-btn" (click)="sendMessage()">Send</button>
  </div>
</div>
